import { useContext, useEffect } from 'react';

import { ContactContext } from 'context/ContactContext';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';
import { getURLParamValue } from 'utility/Provide/Url';

import { ChattyClientDetailOfferParams } from 'types/chatty/offerParams';
import {
    BridgeResponseContext,
    ConnectionInfoDetails,
} from 'types/legacy/wireframe';

import { OPEN_CHATTY_EVENT, UPDATE_SERVICE_CODE } from '../constants';
import { ChattyContextEvent } from '../types';

import { useChatty } from './useChatty';

export const useInitChatty = (offerData?: ChattyClientDetailOfferParams) => {
    const { chattyConfig, check24Wireframe } = useContext(ContactContext);
    const { react } = useContext(CommunicationContext);
    const {
        updateDetails,
        openChatty,
        responseBridgeUpdate,
        connectionInfoDetailRef,
    } = useChatty(offerData);
    const initChatty = () => {
        const element =
            document.querySelector('.c24-travel-js-open-chatbot') ??
            document.createElement('div');

        if (element.className === '') {
            element.className = 'c24-travel-js-open-chatbot c24-travel-hidden';
            document.body.appendChild(element);
        }
        check24Wireframe?.loader.addChatbotElement(chattyConfig, element);
        const isInitialOpen =
            getURLParamValue('showChat') === '1' ||
            getURLParamValue('preSales') === '1';

        if (chattyConfig && check24Wireframe?.loader?.chatty) {
            check24Wireframe.loader.chatty.preloaded = !0;
            check24Wireframe.loader.chatty.init(chattyConfig, isInitialOpen);
            check24Wireframe.loader.hideElements();
        }
    };
    useEffect(() => {
        const updateServiceCode = (serviceCode: string) => {
            if (
                !!serviceCode &&
                serviceCode !== connectionInfoDetailRef.current.serviceCode
            ) {
                updateDetails({ serviceCode });
            }
        };
        react.bind(UPDATE_SERVICE_CODE, updateServiceCode);

        return () => {
            react.unbind(UPDATE_SERVICE_CODE, updateServiceCode);
        };
    }, [react, updateDetails, connectionInfoDetailRef]);

    useEffect(() => {
        const sendData = (e: CustomEvent<ConnectionInfoDetails>) => {
            setTimeout(() => {
                openChatty(e?.detail);
            }, 100);
        };
        document.addEventListener(OPEN_CHATTY_EVENT, sendData);

        return () => {
            document.removeEventListener(OPEN_CHATTY_EVENT, sendData);
        };
    }, [openChatty]);

    useEffect(() => {
        const getData = (e: CustomEvent<BridgeResponseContext>) => {
            responseBridgeUpdate(e.detail);
        };
        document.addEventListener(ChattyContextEvent.RECEIVE_CONTEXT, getData);

        return () => {
            document.removeEventListener(
                ChattyContextEvent.RECEIVE_CONTEXT,
                getData
            );
        };
    }, [responseBridgeUpdate]);

    return { initChatty };
};
